import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-text",
  "use": "icon-text-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-text\">\n<path d=\"M1 2H20V16H5.82046L1 19.4432V2ZM23.5 4.5V22.9432L18.6795 19.5H7.5V17.5H19.3205L21.5 19.0568V4.5H23.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol